import { Box, Button, styled } from '@mui/material';

export const ModalContent = styled(Box)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90%',
	boxShadow: '0px 4px 6px 0px rgba(6, 6, 43, 0.05), 0px 10px 15px -3px rgba(6, 6, 43, 0.10)',
	background: '#FFF',
	outline: 'none',
	borderRadius: '8px',
	display: 'flex',
	justifyContent: 'center',
	'@media (min-width: 768px)': {
		width: '574px',
	},
});

export const ModalCloseButton = styled(Button)({
	position: 'absolute',
	top: '10px',
	right: '10px',
	minWidth: '24px',
	height: '24px',
	fontSize: '24px',
	color: '#9FA6B3',
});
